<script setup>
// NOTICE: KAPTION-INTEGRATION
// Campaign Pill component to display campaign information in conversation view

import { computed } from 'vue';
import { useStore } from 'vuex';

defineProps({
  // eslint-disable-next-line vue/no-unused-properties
  conversationId: {
    type: Number,
    required: true,
  },
});

const store = useStore();

// Get current chat from store
const currentChat = computed(() => store.getters.getSelectedChat);

// Get campaign title from conversation data
const campaignTitle = computed(() => {
  // Campaign data can be in currentChat.campaign or currentChat.meta.campaign
  return (
    currentChat.value?.campaign?.title ||
    currentChat.value?.meta?.campaign?.title
  );
});

const hasCampaign = computed(() => !!campaignTitle.value);
</script>

<template>
  <!-- eslint-disable-next-line vue/valid-v-if -->
  <div v-if="hasCampaign" class="pill-container">
    <div class="pill-campaign bg-[#fafafa] dark:bg-[#000000]">
      <fluent-icon icon="megaphone" size="14" class="pill-icon" />
      <span class="pill-text">{{ campaignTitle }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.pill-container {
  position: sticky;
  top: 1rem;
  z-index: 39; /* NOTICE: KAPTION-INTEGRATION - Lower z-index to allow modals to appear above */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  /* No background, no padding, no margin, no height - container is just for positioning */
  background: none;
  height: 0;
  padding: 0;
  margin: 0;
  pointer-events: none;
  width: 100%;
}

/* Re-enable pointer events on the pill itself */
.pill-campaign {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 9999px;
  transition: all 0.2s ease;
  @apply shadow-md;
  /* Position the pill with margin-top - increased to avoid overlap with AI pill */
  margin-top: 64px;
  /* Solid background */
  position: relative;
  z-index: 1;
  /* Campaign-specific styling */
  @apply bg-n-amber-1 border border-n-amber-3;
  @apply dark:bg-[#1a1a1a] dark:border-n-amber-3/30;
}

.pill-campaign:hover {
  @apply shadow-lg;
  transform: translateY(-1px);
}

.pill-icon {
  @apply text-n-amber-11;
  flex-shrink: 0;
}

.pill-text {
  font-size: 0.875rem;
  font-weight: 500;
  @apply text-n-amber-11;
  white-space: nowrap;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
